export interface SendInviteInputApiModel {
    emails: string[],
    subject: string,
    message: string
}